import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Highcharts = window.Highcharts;

const monthlyCategories = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
const quarterlyCategories = ['Qtr1', 'Qtr2', 'Qtr3', 'Qtr4'];

function Trends({ data, currentYear, previousYear }) {
  const [startYearData, endYearData] = _.partition(data.results, (item) =>
    item.start_date.startsWith(previousYear)
  );

  const bookableProspectsStartData = startYearData.map((item) => item.bookable_calls);
  const bookableProspectsEndData = endYearData.map((item) => item.bookable_calls);

  function createChartOptions(startData, endData, options) {
    const { title, categories } = options;

    return {
      chart: { type: 'column' },
      title: { text: title },
      plotOptions: { series: { dataLabels: { enabled: true } } },
      xAxis: { categories },
      series: [
        { name: previousYear, color: '#0369a1', data: startData },
        { name: currentYear, color: '#65a30d', data: endData },
      ],
      yAxis: { title: { text: undefined } },
      exporting: { enabled: false },
      credits: { enabled: false },
    };
  }

  const bookableProspectsMonthlyTrendOptions = createChartOptions(
    bookableProspectsStartData,
    bookableProspectsEndData,
    { title: 'BOOKABLE PROSPECTS MONTHLY TREND', categories: monthlyCategories }
  );

  let bookableProspectsQuarterlyStartData = [];
  for (let i = 0; i < bookableProspectsStartData.length; i += 3) {
    const sum = bookableProspectsStartData.slice(i, i + 3).reduce((a, b) => a + b, 0);
    bookableProspectsQuarterlyStartData.push(sum);
  }

  let bookableProspectsQuarterlyEndData = [];
  for (let i = 0; i < bookableProspectsEndData.length; i += 3) {
    const sum = bookableProspectsEndData.slice(i, i + 3).reduce((a, b) => a + b, 0);
    bookableProspectsQuarterlyEndData.push(sum);
  }

  const bookableProspectsQuarterlyTrendOptions = createChartOptions(
    bookableProspectsQuarterlyStartData,
    bookableProspectsQuarterlyEndData,
    { title: 'BOOKABLE PROSPECTS QUARTERLY TREND', categories: quarterlyCategories }
  );

  const appointmentsSetStartData = startYearData.map((item) => item.appt_calls);
  const appointmentsSetEndData = endYearData.map((item) => item.appt_calls);

  const appointmentsSetMonthlyTrendOptions = createChartOptions(
    appointmentsSetStartData,
    appointmentsSetEndData,
    { title: 'APPOINTMENTS SET MONTHLY TREND', categories: monthlyCategories }
  );

  let appointmentsSetQuarterlyStartData = [];
  for (let i = 0; i < appointmentsSetStartData.length; i += 3) {
    const sum = appointmentsSetStartData.slice(i, i + 3).reduce((a, b) => a + b, 0);
    appointmentsSetQuarterlyStartData.push(sum);
  }

  let appointmentsSetQuarterlyEndData = [];
  for (let i = 0; i < appointmentsSetEndData.length; i += 3) {
    const sum = appointmentsSetEndData.slice(i, i + 3).reduce((a, b) => a + b, 0);
    appointmentsSetQuarterlyEndData.push(sum);
  }

  const appointmentsSetQuarterlyTrendOptions = createChartOptions(
    appointmentsSetQuarterlyStartData,
    appointmentsSetQuarterlyEndData,
    { title: 'APPOINTMENTS SET QUARTERLY TREND', categories: quarterlyCategories }
  );

  return (
    <div className='row'>
      <div className='col-md-6'>
        <div className='performance_summary_trends_container'>
          <HighchartsReact highcharts={Highcharts} options={bookableProspectsMonthlyTrendOptions} />
          <HighchartsReact
            highcharts={Highcharts}
            options={bookableProspectsQuarterlyTrendOptions}
          />
        </div>
      </div>
      <div className='col-md-6'>
        <div className='performance_summary_trends_container'>
          <HighchartsReact highcharts={Highcharts} options={appointmentsSetMonthlyTrendOptions} />
          <HighchartsReact highcharts={Highcharts} options={appointmentsSetQuarterlyTrendOptions} />
        </div>
      </div>
    </div>
  );
}

Trends.propTypes = {
  data: PropTypes.object.isRequired,
  currentYear: PropTypes.string.isRequired,
  previousYear: PropTypes.string.isRequired,
};

export default Trends;
